import React from 'react';
import { ClockIcon, UsersIcon, TrendingUpIcon, ArrowRightIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function HacksExplained() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-104">
      <div ref={elementRef} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-105">
        <div className="space-y-10" data-id="element-106">
          {/* HACK #1 */}
          <div className="bg-navy-dark p-6 md:p-10 rounded-2xl border border-gold-primary/20 shadow-lg" data-id="element-107">
            <div className="flex items-center gap-4 mb-6" data-id="element-108">
              <div className="bg-gold-primary/10 p-3 rounded-xl border border-gold-primary/30" data-id="element-109">
                <ClockIcon className="w-8 h-8 text-gold-primary" data-id="element-110" />
              </div>
              <div data-id="element-111">
                <p className="text-sm font-bold text-gold-primary uppercase tracking-wider" data-id="element-112">
                  Hack #1
                </p>
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white" data-id="element-113">
                  La Enmienda Que Nadie Hace
                </h3>
              </div>
            </div>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-114">
              ¿Sabías que puedes volver atrás en el tiempo con el IRS?
            </p>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-115">
              Si en años anteriores no reclamaste algo que podías reclamar —
              porque no sabías, porque tu preparador no lo vio, porque no
              calificabas antes y ahora sí — puedes enmendarlo.{' '}
              <span className="text-white font-semibold" data-id="element-116">
                Legalmente. Hoy mismo.
              </span>
            </p>

            <p className="text-sm font-bold text-gold-secondary uppercase tracking-wider mb-3" data-id="element-117">
              Dentro del eBook aprenderás:
            </p>
            <ul className="space-y-2" data-id="element-118">
              <li className="flex items-start gap-3" data-id="element-119">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-120" />
                <span className="text-gray-300" data-id="element-121">
                  Qué situaciones califican para enmienda
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-122">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-123" />
                <span className="text-gray-300" data-id="element-124">
                  Cómo identificar si dejaste dinero en años pasados
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-125">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-126" />
                <span className="text-gray-300" data-id="element-127">
                  El proceso paso a paso para reclamarlo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-128">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-129" />
                <span className="text-gray-300" data-id="element-130">
                  Cuánto tiempo tienes antes de que venza ese derecho
                </span>
              </li>
            </ul>
          </div>

          {/* HACK #2 */}
          <div className="bg-navy-dark p-6 md:p-10 rounded-2xl border border-gold-primary/20 shadow-lg" data-id="element-131">
            <div className="flex items-center gap-4 mb-6" data-id="element-132">
              <div className="bg-gold-primary/10 p-3 rounded-xl border border-gold-primary/30" data-id="element-133">
                <UsersIcon className="w-8 h-8 text-gold-primary" data-id="element-134" />
              </div>
              <div data-id="element-135">
                <p className="text-sm font-bold text-gold-primary uppercase tracking-wider" data-id="element-136">
                  Hack #2
                </p>
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white" data-id="element-137">
                  Tu Hijo Trabaja y Aún Lo Puedes Reclamar
                </h3>
              </div>
            </div>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-138">
              Cuando tu hijo consiguió trabajo, probablemente alguien te dijo:{' '}
              <span className="text-gold-light italic" data-id="element-139">
                "Ya no lo puedes poner como dependiente."
              </span>
            </p>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-140">
              <span className="text-white font-semibold" data-id="element-141">
                Eso no es completamente cierto.
              </span>
            </p>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-142">
              Bajo ciertas condiciones legales, puedes reclamarlo como
              dependiente Y él puede hacer su propia declaración para recuperar
              las retenciones de su trabajo. Dos declaraciones. Dos beneficios.
              Completamente legal si se hace correctamente.
            </p>

            <p className="text-sm font-bold text-gold-secondary uppercase tracking-wider mb-3" data-id="element-143">
              Dentro del eBook aprenderás:
            </p>
            <ul className="space-y-2" data-id="element-144">
              <li className="flex items-start gap-3" data-id="element-145">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-146" />
                <span className="text-gray-300" data-id="element-147">
                  Los factores exactos que deben cumplirse
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-148">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-149" />
                <span className="text-gray-300" data-id="element-150">
                  Cómo estructurarlo para que sea 100% legal
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-151">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-152" />
                <span className="text-gray-300" data-id="element-153">
                  Cuánto dinero adicional puede representar
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-154">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-155" />
                <span className="text-gray-300" data-id="element-156">
                  Cómo protegerte si el IRS pregunta
                </span>
              </li>
            </ul>
          </div>

          {/* HACK #3 */}
          <div className="bg-navy-dark p-6 md:p-10 rounded-2xl border border-gold-primary/20 shadow-lg" data-id="element-157">
            <div className="flex items-center gap-4 mb-6" data-id="element-158">
              <div className="bg-gold-primary/10 p-3 rounded-xl border border-gold-primary/30" data-id="element-159">
                <TrendingUpIcon className="w-8 h-8 text-gold-primary" data-id="element-160" />
              </div>
              <div data-id="element-161">
                <p className="text-sm font-bold text-gold-primary uppercase tracking-wider" data-id="element-162">
                  Hack #3
                </p>
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white" data-id="element-163">
                  Usar La Deuda Del IRS a Tu Favor
                </h3>
              </div>
            </div>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-164">
              ¿Te tocó pagar este año? La reacción normal es pánico. Juntar el
              dinero. Pagarlo todo. Respirar.
            </p>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-165">
              <span className="text-white font-semibold" data-id="element-166">
                Pero esa no es la única opción. Y definitivamente no es la más
                inteligente.
              </span>
            </p>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-167">
              El IRS permite acuerdos de pago. Eso significa que puedes pagar en
              cuotas pequeñas al IRS, tomar ese dinero que ibas a pagar, usarlo
              estratégicamente durante ese período, generar rendimiento con él,
              y pagar tu balance quedándote con la diferencia.
            </p>

            <p className="text-sm font-bold text-gold-secondary uppercase tracking-wider mb-3" data-id="element-168">
              Dentro del eBook aprenderás:
            </p>
            <ul className="space-y-2" data-id="element-169">
              <li className="flex items-start gap-3" data-id="element-170">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-171" />
                <span className="text-gray-300" data-id="element-172">
                  Cómo calcular si esta estrategia te conviene
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-173">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-174" />
                <span className="text-gray-300" data-id="element-175">
                  Cómo solicitar un acuerdo de pago con el IRS
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-176">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-177" />
                <span className="text-gray-300" data-id="element-178">
                  Qué hacer con ese dinero mientras tanto
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-179">
                <ArrowRightIcon className="w-5 h-5 text-gold-primary flex-shrink-0 mt-1" data-id="element-180" />
                <span className="text-gray-300" data-id="element-181">
                  Cuándo NO usar esta estrategia (igual de importante)
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}